(() => {
  if (window.nsImageMenuInstalled) return;
  window.nsImageMenuInstalled = true;
  class NSImageBrowser extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', e => {
        const button = e.target.closest('[data-ns-select]');
        if (!button || !this.contains(button)) return;
        this.querySelectorAll('.ns-menu-panel').forEach(panel => panel.hidden = panel.id !== button.dataset.nsSelect);
        this.querySelectorAll('[data-ns-select]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
      // Non-shopping menus open to their useful direct links, not an empty category.
      const overview = this.querySelector('.ns-menu-panel--overview');
      if (overview) {
        this.querySelectorAll('.ns-menu-panel').forEach(p => p.hidden = p !== overview);
        this.querySelectorAll('[data-ns-select]').forEach(b => b.setAttribute('aria-pressed','false'));
      }
    }
  }
  if (!customElements.get('ns-image-browser')) customElements.define('ns-image-browser',NSImageBrowser);
  function setup(root = document) {
    root.querySelectorAll('[data-ns-menu]').forEach(details => {
      if (details.dataset.ready) return;
      details.dataset.ready = 'true';
      const summary = details.querySelector('summary');
      let timer;
      const open = () => {
        clearTimeout(timer);
        document.querySelectorAll('[data-ns-menu][open]').forEach(other => { if (other !== details) other.open = false; });
        details.open = true;
      };
      details.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') open(); });
      details.addEventListener('pointerleave', e => { if (e.pointerType === 'mouse') timer = setTimeout(() => { if (!details.contains(document.activeElement)) details.open = false; },180); });
      summary.addEventListener('click', e => { e.preventDefault(); if (e.detail > 0 && matchMedia('(hover:hover) and (pointer:fine)').matches) open(); else details.open ? details.open = false : open(); });
      details.addEventListener('toggle', () => summary.setAttribute('aria-expanded',String(details.open)));
      details.addEventListener('keydown', e => { if (e.key === 'Escape') { details.open = false; summary.focus(); } if (e.key === 'ArrowDown' && e.target === summary) {e.preventDefault();open();details.querySelector('.ns-menu-category')?.focus();} });
      details.addEventListener('focusout', () => requestAnimationFrame(() => { if (!details.contains(document.activeElement)) details.open = false; }));
    });
    root.querySelectorAll('.ns-menu-mobile').forEach(dialog => {
      if (dialog.dataset.ready || typeof dialog.showModal !== 'function') return;
      dialog.dataset.ready = 'true';
      const section = dialog.closest('.shopify-section');
      const trigger = section?.querySelector('button[aria-controls="header-sidebar-menu"]');
      if (!trigger) return;
      trigger.setAttribute('aria-controls',dialog.id);
      trigger.setAttribute('aria-expanded','false');
      let previousOverflow;
      trigger.addEventListener('click', e => {
        e.preventDefault(); e.stopImmediatePropagation();
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal(); document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded','true');
      },true);
      dialog.querySelector('[data-ns-close]').addEventListener('click', () => dialog.close());
      dialog.querySelectorAll('[data-ns-localization]').forEach(select => select.addEventListener('change', () => select.form.requestSubmit()));
      if (dialog.classList.contains('ns-menu-mobile--v4')) {
        const views = [...dialog.querySelectorAll('[data-ns-hub-view]')];
        const nav = dialog.querySelector('.ns-hub-navigation');
        const scroller = dialog.querySelector('.ns-menu-mobile__scroll');
        const showHub = (name, moveFocus = false) => {
          if (!views.some(view => view.dataset.nsHubView === name)) return;
          views.forEach(view => view.hidden = view.dataset.nsHubView !== name);
          nav.querySelectorAll('[data-ns-hub]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.nsHub === name)));
          if (name === 'guide') dialog.querySelectorAll('[data-ns-guide-group]').forEach(group => group.open = true);
          scroller.scrollTop = 0;
          dialog.querySelectorAll('[data-ns-hub-view]:not([hidden]) img').forEach(img => img.loading = 'eager');
          if (moveFocus) nav.querySelector(`[data-ns-hub="${name}"]`)?.focus({preventScroll:true});
        };
        dialog.addEventListener('click', event => {
          const button = event.target.closest('[data-ns-hub]');
          if (button && dialog.contains(button)) showHub(button.dataset.nsHub, !nav.contains(button));
        });
        dialog.addEventListener('close', () => showHub('overview'));
      }
      if (dialog.classList.contains('ns-menu-mobile--v3')) {
        const tabs = [...dialog.querySelectorAll('[data-ns-category]')];
        const selectCategory = button => {
          tabs.forEach(tab => { const selected = tab === button; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; });
          dialog.querySelectorAll('.ns-switch-panel').forEach(panel => panel.hidden = panel.id !== button.dataset.nsCategory);
          dialog.querySelector('.ns-switch-content').scrollTop = 0;
          dialog.querySelectorAll('.ns-switch-panel:not([hidden]) img').forEach(img => img.loading = 'eager');
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectCategory(tab));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
            else if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = tabs.length - 1;
            else return;
            event.preventDefault(); selectCategory(tabs[next]); tabs[next].focus({preventScroll:true});
          });
        });
        dialog.addEventListener('close', () => {
          dialog.querySelectorAll('.ns-switch-support details[open], .ns-switch-support[open]').forEach(d => d.open = false);
          dialog.querySelector('.ns-menu-mobile__scroll').scrollTop = 0;
        });
      }
      // Mobile uses a full-width view stack; retain the earlier markup handler
      // so cached HTML continues to work during a scoped live deployment.
      if (dialog.classList.contains('ns-menu-mobile--v2')) {
        const scroller = dialog.querySelector('.ns-menu-mobile__scroll');
        const home = dialog.querySelector('[data-ns-view="home"]');
        const back = dialog.querySelector('[data-ns-back]');
        const title = dialog.querySelector('[data-ns-mobile-title]');
        let returnButton, homeScroll = 0;
        const goHome = () => {
          dialog.querySelectorAll('[data-ns-view]').forEach(view => view.hidden = view !== home);
          back.hidden = true; title.textContent = 'Explore NSABERS';
          scroller.scrollTop = homeScroll;
          returnButton?.focus({preventScroll:true});
        };
        dialog.addEventListener('click', event => {
          const button = event.target.closest('[data-ns-go]');
          if (!button || !dialog.contains(button)) return;
          const view = document.getElementById(button.dataset.nsGo);
          if (!view || !dialog.contains(view)) return;
          returnButton = button; homeScroll = scroller.scrollTop;
          dialog.querySelectorAll('[data-ns-view]').forEach(panel => panel.hidden = panel !== view);
          back.hidden = false; title.textContent = view.dataset.nsTitle;
          back.setAttribute('aria-label','Back to menu');
          scroller.scrollTop = 0; back.focus({preventScroll:true});
        });
        back.addEventListener('click',goHome);
        dialog.addEventListener('close', () => {goHome();homeScroll=0;scroller.scrollTop=0;});
      }
      dialog.addEventListener('close', () => {document.documentElement.style.overflow = previousOverflow || '';trigger.setAttribute('aria-expanded','false');trigger.focus();});
      dialog.addEventListener('click', e => {
        const button = e.target.closest('[data-ns-mobile-select]');
        if (!button) return;
        dialog.querySelectorAll('.ns-menu-mobile__panel').forEach(p => p.hidden = p.id !== button.dataset.nsMobileSelect);
        dialog.querySelectorAll('[data-ns-mobile-select]').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
        dialog.querySelector('.ns-menu-mobile__content').scrollTop = 0;
      });
      const media = matchMedia('(min-width:1150px)');
      media.addEventListener('change', () => { if(media.matches && dialog.open) dialog.close(); });
      if (window.Shopify?.designMode) {
        section.addEventListener('shopify:block:select', event => {
          const panel = [...dialog.querySelectorAll('[data-ns-series-block]')].find(p => p.dataset.nsSeriesBlock === event.detail.blockId);
          if (!panel || media.matches) return;
          if (!dialog.open) trigger.click();
          dialog.querySelector('.ns-hub-navigation [data-ns-hub="shop"]')?.click();
          dialog.querySelector(`[data-ns-category="${panel.id}"]`)?.click();
        });
        if (dialog.querySelector('[data-ns-editor-open]') && !media.matches) trigger.click();
      }
    });
  }
  document.addEventListener('click', e => {document.querySelectorAll('[data-ns-menu][open]').forEach(d => { if(!d.contains(e.target)) d.open = false; });});
  document.addEventListener('shopify:section:load', e => setup(e.target));
  document.addEventListener('shopify:section:unload', e => {
    const dialog = e.target.querySelector('.ns-menu-mobile[open]');
    if (dialog) dialog.close();
  });
  setup();
})();
